<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :loading="$apollo.loading"
    :search="search"
    :hide-default-footer="hideFooter"
  >
    <template v-slot:item.validFrom="{item}">{{item.validFrom | formatDate }}</template>
    <template v-slot:item.validTo="{item}">{{item.validTo | formatDate }}</template>
    <template v-slot:item.actions="{item}">
      <default-list-actions
        :item="item"
        :hide-view="true"
        @deleteItem="deleteItem($event)"
        @editItem="editItem($event)"
      ></default-list-actions>
    </template>
  </v-data-table>
</template>

<script>
import DefaultListActions from "../../shared/DefaultListActions";
export default {
  name: "taxes-table",
  props: {
    headers: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      default: () => []
    },
    search: {
      type: String,
      default: () => ""
    },
    hideFooter: {
      type: Boolean,
      defaultd: () => false
    }
  },
  components: { DefaultListActions },
  methods: {
    deleteItem(payload) {
      this.$emit("delete", payload);
    },
    editItem(payload) {
      this.$emit("edit", payload);
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/gt/suppliers/taxes/TaxesTable.vue